import React from "react";

import { Body, Filters, I } from "components/prime-data-table";

export const auditColumns: I.IPrimeTableColumn[] = [
    {
        header: "Visible on CP",
        field: "isVisibleOnCp",
        sortable: true,
        filterBody: Filters.checkbox,
        body: Body.checkbox,
    },
];
